import { ButtonHTMLAttributes, RefObject } from 'react'
import { HugeiconsIcon, HugeiconsIconProps } from '@hugeicons/react'
import { Loading01Icon, PlusSignIcon } from '@hugeicons/core-solid-rounded'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  ref?: RefObject<HTMLButtonElement>
  icon: HugeiconsIconProps['icon']
  loading?: boolean
}

export function IconButton({ ref, icon, loading, ...props }: Props) {
  return (
    <button
      className="size-10 rounded-small bg-primary p-2.5 text-white"
      type="button"
      tabIndex={0}
      ref={ref}
      {...props}
    >
      {loading && (
        <div className="flex w-full flex-row items-center justify-center leading-[inherit]">
          <HugeiconsIcon icon={Loading01Icon} className="size-4 animate-spin" />
        </div>
      )}
      {!loading && <HugeiconsIcon icon={icon} className="size-full" />}
    </button>
  )
}

type AddButtonProps = Omit<Props, 'icon'>

export function AddButton(props: AddButtonProps) {
  return <IconButton icon={PlusSignIcon} {...props} />
}
